import React, { useEffect, useState } from "react";
import { Grid } from "react-feather";
import Footer from "../footer";
import Header2 from "../header2/index-two";
import SubKatChard from "../sub/SubKatChard";
// import axios from "axios";
import { useLocation } from "react-router-dom";
import axiosInstance from "../../axios";
export default function Subresult() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jenis = params.get("jenis");
  const komoditi = params.get("komoditi");

  // axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  
  const [subkat, setSubkat] = useState([])
  const [countpar, setCountpar] = useState()
  const [countkat, setCountkat] = useState()
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState('')

  useEffect(()=>{
    setLoaded(false)
    setError('')

    const getSubkat = async() =>{
      try {
        let res = await axiosInstance.post('https://bbpom-makassar.com/api/search-sub', {
          jenis: jenis,
          comodity: komoditi,
        });
        setSubkat(res.data.data || [])
        // setParameter(res.data.par)
        setCountkat(res.data.count)
        setCountpar(res.data.countpar)
      } catch (e) {
        console.log(e.message)
        setSubkat([])
        setCountkat(undefined)
        setCountpar(undefined)
        // Endpoint /api/search-sub dibatasi 60 permintaan per menit.
        setError(e.response?.status === 429
          ? 'Terlalu banyak pencarian dalam satu menit. Tunggu sebentar, lalu coba lagi.'
          : 'Hasil pencarian gagal dimuat. Periksa sambungan Anda, lalu coba lagi.')
      } finally {
        setLoaded(true)
      }
    }

    getSubkat()
  },[jenis, komoditi])



  console.log('hasil',subkat)
  return (
    <div className="main-wrapper">
      <Header2 
        activeMenu={"List"} 
      />
     

      {/* Page Wrapper */}
      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Filter */}
              <div className="showing-list">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="d-flex align-items-center">
                      <div className="view-icons">
                        
                        <span className="list-view active">
                          <Grid size={19} />
                        </span>
                      </div>
                      <div className="show-result">
                      {!loaded ? (
                        <h4>Memuat hasil pencarian…</h4>
                      ) : error ? (
                        <h4>Pencarian gagal</h4>
                      ) : countkat == null ? (
                        <h4>Tidak ada hasil</h4>
                      ) : (
                        <h4>Showing {countkat} results, with {countpar} total parameter</h4>
                      )}
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Filter */}
              <div className="row">
              </div>
              <div className="row">
                {/* Instructor List */}
                <div className="col-lg-12">
                  <div className="student-grid-blk">
                  <div className="row">
                  {!loaded ? (
                    <center>
                      <div className="spinner-border text-center" style={{ marginTop: "20px" }}></div>
                    </center>
                  ) : error ? (
                    <center>
                      <p style={{ marginTop: "20px" }}>{error}</p>
                    </center>
                  ) : subkat.length === 0 ? (
                    <h5 style={{textAlign:'center'}}>Pencarian tidak menemukan hasil.</h5>
                  ) : (subkat.map((sub,index)=>{
                      return(
                        <SubKatChard
                        key = {index}
                        title = {sub.nm_sub_kategory}
                        id= {sub.id}
                        header={sub.uji_kategory.nm_kategory}
                        parameter={sub.transuji_count}
                        />
                      )}))
                  }
                  </div>
                  </div>
                </div>
                {/* Instructor List */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Page Wrapper */}
      <Footer />
    </div>
  );
}
